module.exports = __webpack_public_path__ + "2b5290ca78578632746d234639f3c5e7.woff2";